import React, { useState } from 'react';
import { ILivsHistorie, TFelt } from './livsHistorie.definition';
import { Select } from '../InputFelter';
import Form from '../GenericForm';
import { convertValuesToSingleObject, generateDefaultValues, generateInitialSelected, mapLivsHistorie } from './livshistorie.utils';
import { opretLivsHistorie } from '@Utils/serviceTjekApi';
import { useMutation } from '../../../hooks/useMutation';
import Tooltip from '@Components/ServiceTjek/Tooltip';
import LoadingSpinner from '@Components/loadingSpinner';

const renderField = ({ control }, selected, onOptionSelect) => {
	const Field = (field: TFelt) => {
		const { feltId, type } = field;

		const hasRelations = selected && selected.length > 0 && selected.some(select => {
			const { relations } = select;
			return relations && relations.length > 0 ? relations.includes(feltId) : false;
		});

		const showByOption = hasRelations && selected.some(select => {
			const { visIds } = select;
			return visIds && visIds.length > 0 ? visIds.includes(feltId) : false;
		});

		if (hasRelations && !showByOption) {
			return null;
		}

		if (type === 'text') {
			const { text } = field;
			const ordDeltOp = text.split(' ');
			return ordDeltOp.map((ord, index) => <span data-id={ feltId } className="livshistorie__ord" key={ ord + index }>{ ord }</span>);
		} else if (type === 'input') {
			const {
				name,
				inputType,
				defaultValue,
				placeholder
			} = field;

			switch (inputType) {
			case 'text':
				// return  <input key={field.name} ref={register} defaultValue={field.defaultValue} type={inputType} />
				break;
			case 'dropdown':
				return (
					<Select
						key={ name }
						className="livshistorie__select"
						id="dropdown_010_dim2"
						defaultValue={ defaultValue }
						placeholder={ placeholder }
						name={ name }
						control={ control }
						options={ field.options }
						onOptionSelect={ onOptionSelect }
					/>
				);
			case 'number':
				// return <input {...input} ref={register} type={inputType} key={input.name} />
				break;
			default:
				return <pre>No render for field</pre>;
			}
		}
	};

	return Field;
};


const LivsHistorie = ({ sektioner, livsHistorieId, endpointUrl, overskrift, noter, indsendKnapTekst, actionLink }: ILivsHistorie) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleSuccess = response => {
		if (response.Success && response.RedirectUrl) {
			window.location.href = response.RedirectUrl;
		}
	};

	const { mutate } = useMutation((payload) => opretLivsHistorie(endpointUrl, payload), {
		onError: (err) => {
			console.error(err);
			setIsLoading(false);
		},
		onSucces: handleSuccess
	});

	if (!sektioner) {
		return null;
	}

	const onSubmit = payload => {
		setIsLoading(true);
		mutate(mapLivsHistorie(convertValuesToSingleObject(payload), livsHistorieId));
	};

	const defaultValues = generateDefaultValues(sektioner);

	const selectedInitial = generateInitialSelected(sektioner);

	const [selected, setSelected] = useState(selectedInitial);

	const onOptionSelect = (selectId, optionId, ids) => {
		const visIds = ids ? ids.split(',') : null;

		const relatedDeep = [...selected].map(select => {
			if (select.selectId === selectId) {
				return select.relations;
			}

			return null;
		}).filter(s => s);

		const related = relatedDeep && relatedDeep.length > 0 ? relatedDeep[0] : null;

		const newFieldIds = [...selected].map(select => {
			if (select.selectId === selectId) {
				return {
					...select,
					visIds: visIds
				};
			}

			return select;
		});

		const resetRelated = newFieldIds.map(select => {
			if (related && related.includes(select.selectId)) {
				return {
					...select,
					visIds: null
				};
			}

			return select;
		});

		setSelected(resetRelated);
	};

	return (
		<section id={ livsHistorieId } className="servicetjek-livshistorie f-grid">
			{ overskrift && (
				<div className="col-sm-6 col-md-12 col-lg-12 justify-content-center mb-3 sm:mb-1">
					<h1 className="text-sm color-black--60">{ overskrift }</h1>
				</div>
			) }
			<div className="col-lg-6 col-lg-shift-3 col-md-6 col-md-shift-3 col-sm-6 col-sm-shift-0">
				<Form onSubmit={ onSubmit } defaultValues={ defaultValues }>
					{ ({ /*register,*/ control }) => (
						<div className="center-vert form-inner">
							<div className="text-center">
								{ sektioner.map((sektion, idx) => (
									<div
										key={ idx }
										className="mb-3 sm:mb-1 d-flex flex-wrap justify-content-center text-xl responsive"
									>
										{ sektion.felter.map(renderField({ /*register, */ control }, selected, onOptionSelect)) }
									</div>
								)) }

								{ noter && noter.length > 0 && (
									noter.map((note, idx) => (
										<div key={ idx } className="mb-1" >
											{ note.note &&
												<Tooltip text={ note.hoverNote } isText={ String(note.note) } /> }
										</div>
									))
								) }

								{ actionLink && actionLink.url && (
									<a
										href={ actionLink.url }
										target={ actionLink.target }
										className="button button--liv"
									>
										{ actionLink.title }
									</a>
								) }
								{ !isLoading && indsendKnapTekst &&
									<button type="submit" className="button button--liv" id="knap_010_dim2">{ indsendKnapTekst }</button> }
								<LoadingSpinner isLoading={ isLoading } />
							</div>
						</div>
					) }
				</Form>
			</div>
		</section>
	);
};

export default LivsHistorie;
